export default "__VITE_ASSET__yuJJKl2N__"